module.exports = __webpack_public_path__ + "img/ruby.88d236c5.png";